import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { billingEndpoints as endpoint } from '@/api/endpoints';
import { callGet } from '@/api/fetcher';
import { BillingState } from '@/modules/billing/model';
import { selectAccountSlug } from '@/redux/session/selectors';
import { SIGNUP_TRIAL_PERIOD_IN_DAYS } from '@/util/constants';
import { clampPercentage } from '@/util/limits';

export const TRIAL_DAYS = SIGNUP_TRIAL_PERIOD_IN_DAYS;

export const getPercentage = (days_left: number) => {
  if (days_left <= 0) {
    return 100;
  }
  return clampPercentage(TRIAL_DAYS - days_left, TRIAL_DAYS);
};

export const useBillingState = () => {
  const accountSlug = useSelector(selectAccountSlug);
  const { data: billingState } = useQuery<BillingState>({
    queryKey: [endpoint.billingState, accountSlug],
    queryFn: () => callGet(endpoint.billingState),
    enabled: !!accountSlug,
  });

  return billingState;
};
